(function ($) {
  'use strict';

  if (window.EngravingController) return;

  const settings = window.EngravingCampaignSettings || { enabled: false, variantIds: [] };

  const EngravingController = {
    _syncing: false,
    _observer: null,

    init() {
      if (!settings.enabled) return;

      $(document).ready(() => {
        this.syncFromCartData();
        this.observeCartData();
      });
    },

    getCartData() {
      const cartData = document.getElementById('cart-data');
      if (!cartData) return null;
      try {
        return JSON.parse(cartData.textContent || cartData.innerText);
      } catch (e) {
        return null;
      }
    },

    isEngravingItem(item) {
      if (item.handle === 'add-engraving' || item.handle.indexOf('item-personalization') >= 0) return true;
      if (settings.variantIds.length && settings.variantIds.indexOf(item.variant_id) >= 0) return true;
      return false;
    },

    // Replicates Shopify Script Editor Ruby logic:
    // engravings += line_item.quantity for each item with any engraving property key.
    calculateExpectedQty(cart) {
      const totals = {};
      const engravingKeys = ['Add Engraving?', 'Add Right Engraving?', 'Add Back Engraving', 'Engraving Added'];

      cart.items.forEach((item) => {
        if (this.isEngravingItem(item)) return;

        const engravingVariantId = item.properties && item.properties['_engraving_product_id'];
        if (!engravingVariantId) return;

        const hasEngravingKey = Object.keys(item.properties).some((key) => engravingKeys.some((trigger) => key.indexOf(trigger) >= 0));
        if (!hasEngravingKey) return;

        totals[engravingVariantId] = (totals[engravingVariantId] || 0) + item.quantity;
      });

      return totals;
    },

    getUpdatesNeeded(cart, expectedByVariant) {
      const updates = {};
      let hasUpdates = false;

      // Check if any regular (non-engraving) items with engraving properties exist
      const hasRegularEngravingItems = Object.keys(expectedByVariant).length > 0;

      cart.items.forEach((item) => {
        if (!this.isEngravingItem(item)) return;

        // If no regular engraved products remain, delete orphan engraving items
        if (!hasRegularEngravingItems) {
          if (item.quantity > 0) {
            updates[item.key] = 0;
            hasUpdates = true;
          }
          return;
        }

        const expected = expectedByVariant[item.variant_id] || 0;
        if (item.quantity !== expected) {
          updates[item.key] = expected;
          hasUpdates = true;
        }
      });

      return hasUpdates ? updates : null;
    },

    syncFromCartData() {
      if (this._syncing) return;

      const cart = this.getCartData();
      if (!cart || !cart.items) return;

      const expectedByVariant = this.calculateExpectedQty(cart);
      const updates = this.getUpdatesNeeded(cart, expectedByVariant);
      if (!updates) return;

      this._syncing = true;

      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        dataType: 'json',
        data: { updates },
        success: (updatedCart) => {
          Shopify.getCart((freshCart) => {
            if (typeof refreshCart === 'function') {
              refreshCart(freshCart, false);
            }
            this._syncing = false;
          }, updatedCart);
        },
        error: () => {
          this._syncing = false;
        }
      });
    },

    observeCartData() {
      const cartItemsEl = document.querySelector('.js-cart_items');
      if (!cartItemsEl) return;

      this._observer = new MutationObserver((mutations) => {
        if (this._syncing) return;

        const cartDataAdded = mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some((node) => node.id === 'cart-data')
        );

        if (cartDataAdded) this.syncFromCartData();
      });

      this._observer.observe(cartItemsEl, { childList: true });
    }
  };

  window.EngravingController = EngravingController;
  EngravingController.init();
}(jQuery));
